import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	createAccount: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		data: {}
	}
};

export const createAccountSlice = createSlice({
	name: 'createAccount',
	initialState,
	reducers: {
		createAccount: (state) => {
			state.createAccount.isLoading = true;
		},
		createAccountCompleted: (state, action) => {
			state.createAccount.isLoading = false;
			state.createAccount.hasCompleted = true;
			state.createAccount.data = action.payload;
		},
		createAccountFailed: (state, action) => {
			state.createAccount.isLoading = false;
			state.createAccount.error = action.payload;
		},
		createAccountReset: (state) => {
			state.createAccount = initialState.createAccount;
		}
	}
});

export const {
	createAccount,
	createAccountCompleted,
	createAccountFailed,
	createAccountReset
} = createAccountSlice.actions;

export default createAccountSlice.reducer;
